import { render } from "./investmentUser.vue?vue&type=template&id=f3b41362&scoped=true"
import script from "./investmentUser.vue?vue&type=script&lang=js"
export * from "./investmentUser.vue?vue&type=script&lang=js"

import "./investmentUser.vue?vue&type=style&index=0&id=f3b41362&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3b41362"]])

export default __exports__